import { formatDate } from '@frontend/mwm-ui'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

const DateISOCellRenderer = ({ value }: ICellRendererParams<unknown, string>): ReactElement => {
  return <span className="text">{value ? formatDate(value) : ''}</span>
}

export default DateISOCellRenderer
